import React from 'react';
import { Typography, Box } from '@mui/material';

interface BilingualLabelProps {
  es: string;
  en: string;
  /** When true, renders inline "ES / EN" instead of stacked. */
  inline?: boolean;
  variant?: 'body2' | 'caption' | 'subtitle2';
  bold?: boolean;
  color?: string;
  secondaryColor?: string;
}

const BilingualLabel: React.FC<BilingualLabelProps> = ({
  es,
  en,
  inline = false,
  variant = 'body2',
  bold = false,
  color = '#374151',
  secondaryColor = '#6b7280',
}) => {
  if (inline) {
    return (
      <Typography variant={variant} sx={{ color, fontWeight: bold ? 700 : 400 }}>
        <Box component="span" sx={{ fontWeight: bold ? 700 : 600 }}>{es}</Box>
        <Box component="span" sx={{ color: secondaryColor, mx: 0.5 }}>/</Box>
        <Box component="span" sx={{ color: secondaryColor }}>{en}</Box>
      </Typography>
    );
  }

  return (
    <Box>
      <Typography variant={variant} sx={{ color, fontWeight: bold ? 700 : 600, lineHeight: 1.3 }}>
        {es}
      </Typography>
      <Typography variant="caption" sx={{ color: secondaryColor, lineHeight: 1.2, display: 'block' }}>
        {en}
      </Typography>
    </Box>
  );
};

export default BilingualLabel;
